<p-toast position="top-right" key="maintoast"></p-toast>
<!-- <app-spinner></app-spinner> -->
<app-layout [logoUrl]="'https://files.saraplus.com/images/saraplusweb/SARA_logo-short_favicon.png'" [menuItems]="items"
  [isLoggedIn]="isLoggedIn">
  <router-outlet></router-outlet>
</app-layout>
<p-scrollTop [threshold]="100" icon="pi pi-arrow-up" styleClass="left-0 ml-2"></p-scrollTop>